import * as React from 'react';
import { ContainerClient } from '@azure/storage-blob';
import { SemanticIcon, SemanticIconName, SemanticIconSize } from '../Icons';
import { Label } from '../Label';
import { ProgressIndicator } from '../ProgressIndicator';
import { Spinner, SpinnerSize } from '../Spinner';
import { Stack } from '../Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function UploadFile(_ref) {
  let {
    containerUrl,
    file,
    path,
    preventUpload,
    uploadIcon = /*#__PURE__*/_jsx(Spinner, {
      size: SpinnerSize.large
    }),
    completeIcon = () => /*#__PURE__*/_jsx(SemanticIcon, {
      semanticName: SemanticIconName.Yes,
      size: SemanticIconSize.Large
    }),
    errorIcon = /*#__PURE__*/_jsx(SemanticIcon, {
      semanticName: SemanticIconName.Alert,
      size: SemanticIconSize.Large
    }),
    onComplete,
    onProgress,
    onError
  } = _ref;
  const containerClientRef = React.useRef(null);
  if (containerClientRef.current === null) {
    containerClientRef.current = new ContainerClient(containerUrl);
  }
  const blockClient = containerClientRef.current.getBlockBlobClient(path ? "".concat(path, "/").concat(file.name) : file.name);
  const [percent, setPercent] = React.useState(0);
  const [error, setError] = React.useState('');
  const [complete, setComplete] = React.useState(false);
  React.useEffect(() => {
    if (!preventUpload) {
      uploadBuffer(file);
    }
  }, [file]);
  React.useEffect(() => {
    if (preventUpload) {
      setError(preventUpload);
      if (onError) {
        onError({
          url: blockClient.url,
          file,
          error
        });
      }
    }
  }, [preventUpload]);
  const uploadBuffer = async file => {
    if (!containerClientRef.current) {
      return;
    }
    let error = undefined;
    try {
      await blockClient.uploadBrowserData(file, {
        onProgress: progress => {
          setPercent(progress.loadedBytes / file.size);
          if (onProgress) {
            onProgress(percent);
          }
        }
      });
    } catch (e) {
      if (onError) {
        error = e;
        setPercent(0);
        setError(' ! Upload Error, please check if valid filename');
        onError({
          url: blockClient.url,
          file,
          error
        });
      }
    } finally {
      setComplete(true);
      if (onComplete) {
        onComplete({
          url: blockClient.url,
          file,
          error
        });
      }
    }
  };
  return /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 5
    },
    children: [error ? errorIcon : complete ? completeIcon({
      uploaded: {
        url: blockClient.url,
        file,
        error
      }
    }) : uploadIcon, /*#__PURE__*/_jsx(Stack.Item, {
      grow: true,
      children: /*#__PURE__*/_jsx(ProgressIndicator, {
        label: file.name + ' ' + error,
        description: file.type,
        percentComplete: percent,
        styles: {
          itemName: {
            color: error ? 'red' : ''
          }
        }
      })
    }), /*#__PURE__*/_jsx(Stack.Item, {
      children: /*#__PURE__*/_jsxs(Label, {
        children: [Math.floor(percent * 100), " %"]
      })
    })]
  });
}